module.exports = /(Edge\/(1[2-8](?:\.0)?|(79|80|81)(?:\.0)?|(8[3-9]|9[0-5])(?:\.0)?))|(Trident\/7\.0)|(Trident\/6\.0)|(Trident\/5\.0)|(Trident\/4\.0)|(([MS]?IE) (5\.5|([6-9]|1[0-1])\.0))/;
